import { Search } from "@mui/icons-material";
import { Grid } from "@mui/material";
import { Link } from "react-router-dom";
import styled from "styled-components";

export const StyledFilter = styled.div`
    .MuiFormLabel-root {
        font-size: 15px;
        line-height: 20px;
        white-space: nowrap;
    }

    .MuiFormControl-root {
        padding-bottom: 0;
        margin-top: 10px;
    }

    .MuiBox-root {
        border: none;
    }
`;

export const TableFilter = styled(Grid)`
    margin-bottom: 30px;
    align-items: flex-end;

    .MuiGrid-root:not(:last-child) {
        margin-right: 15px;
        min-width: 100px;
    }
`;

export const StyledSearch = styled(Search)`
    && {
        font-size: 22px;
        fill: #242424;
    }
`;

export const StyledLink = styled(Link)`
    color: black;
    font-size: 16px;
`;
